<template>
  <div>
    <p v-if="isSpecsUpdated" class="flex flex-wrap gap-x-4">
      <span class="text-static-brand-hi body-1-bold">
        {{ i18n(translations.productGrade) }}
      </span>
      <span class="text-static-default-low body-1-striked">
        {{
          getGradeName(
            original.grade.value,
            original.grade.name ?? '',
            hasNewBattery(original),
          )
        }}
      </span>
      <span class="text-static-brand-hi body-1-bold">
        {{
          getGradeName(
            replacement.grade.value,
            replacement.grade.name ?? '',
            replacement.offerType.value === 7,
          )
        }}
      </span>
    </p>
    <p v-else-if="isCheaper" class="text-static-default-hi body-1">
      {{ i18n(translations.priceLower) }}
    </p>
    <p v-else class="text-static-default-hi body-1">
      {{ i18n(translations.priceHigher) }}
    </p>

    <div
      v-if="mobilePlan?.selectedOffer && hasSubsidy(mobilePlan.selectedOffer)"
      class="text-static-success-hi body-1-bold"
    >
      {{
        i18n(translations.bundlingDiscount, {
          price: i18n.price(mobilePlan.selectedOffer.subsidy),
        })
      }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import { hasSubsidy } from '@backmarket/nuxt-layer-checkout/utils/mobilePlan/hasSubsidy'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { ReplacementOption } from '~/api/checkout/cart/types'

import translations from './ReplacementDescription.translations'

const props = defineProps<{
  mobilePlan?: { selectedOffer: MobilePlanOffer } | null
  original: ReplacementOption
  categoryId: number
  replacement: ReplacementOption
}>()

const i18n = useI18n()

function hasNewBattery(replacement: ReplacementOption) {
  return replacement.offerType.value === 7
}

const isGradeUpdated = computed(() => {
  return props.original.grade.value !== props.replacement.grade.value
})

const isOfferTypeUpdated = computed(() => {
  return hasNewBattery(props.original) !== hasNewBattery(props.replacement)
})

const isSpecsUpdated = computed(() => {
  return isGradeUpdated.value || isOfferTypeUpdated.value
})

const isCheaper = computed(() => {
  return (
    parseInt(props.original.price.amount, 10) >
    parseInt(props.replacement.price.amount, 10)
  )
})

function getGradeName(
  gradeId: number,
  gradeName: string,
  withNewBattery: boolean,
) {
  if (withNewBattery) {
    return i18n(translations.productGradeWithNewBattery, {
      grade: gradeName,
    })
  }

  return gradeName
}
</script>
